import { RenderLeafProps } from 'slate-react';
import React from 'react';

import {
  Bold as StyledBold,
  Code as StyledCode,
  Colour as StyledColour,
} from './RichText.styled';
import { textColours } from '../../plugins/richtext/colours';

export const Bold = ({ children, attributes }: RenderLeafProps) => (
  <StyledBold {...attributes}>{children}</StyledBold>
);
export const Italic = ({ children, attributes }: RenderLeafProps) => (
  <em {...attributes}>{children}</em>
);
export const Underline = ({ children, attributes }: RenderLeafProps) => (
  <u {...attributes}>{children}</u>
);
export const StrikeThrough = ({ children, attributes }: RenderLeafProps) => (
  <s {...attributes}>{children}</s>
);
export const InlineCode = ({ children, attributes }: RenderLeafProps) => (
  <StyledCode {...attributes}>{children}</StyledCode>
);
export const Colour = ({ children, attributes, leaf }: RenderLeafProps) => {
  const colour = typeof leaf.c === 'string' ? textColours[leaf.c] : undefined;

  return (
    <StyledColour {...attributes} colour={colour}>
      {children}
    </StyledColour>
  );
};
